import { isFunction } from '@xemplo/common-util';
import { ListValue } from '@xemplo/stateful-list-core';

export type MaxTagsValidatorProps = {
  maxTags?: number;
  message?: string | ((tags: ListValue[]) => string);
};

export function maxTagsValidator({
  maxTags = 10,
  message = `You can only add up to ${maxTags} tags.`,
}: MaxTagsValidatorProps = {}) {
  return (tags: ListValue[]) => {
    if (tags.length > maxTags) {
      return isFunction(message) ? message(tags) : message;
    }
    return true;
  };
}
